import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import Sidebar from './Sidebar';
import { HeaderAdmin } from '../pages/admin/HeaderAdmin';

interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * Aqui existia `integrarDadosSympla`, que chamava POST /users/import/sympla com o
 * eventId e o s_token da Sympla escritos no fonte. Como este componente envolve todas
 * as paginas do admin, o token ia junto no bundle publico — legivel por qualquer um,
 * inclusive nos source maps dos builds antigos. O token foi rotacionado na Sympla.
 *
 * A importacao por API volta como conector configuravel na tela de Integracoes, com a
 * credencial guardada cifrada no servidor e nunca entregue ao navegador. Ate la nao ha
 * atalho: qualquer botao que precise de segredo para funcionar publica esse segredo.
 */
const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const bgColor = useColorModeValue('gray.50', 'gray.900');

  return (
    <Flex minH="100vh" bg={bgColor}>
      {/* Sidebar */}
      <Sidebar />

      {/* Conteúdo Principal */}
      <Box flex="1" ml={{ base: 0, lg: '240px' }}>
        {/* Header fixo no topo */}
        <HeaderAdmin />

        {/* Conteúdo das páginas */}
        {children}
      </Box>
    </Flex>
  );
};

export default AdminLayout;
